import axios from "axios"
import baseURL from "../configs/api"

export const post_ReservationExtension = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}extension?userId=${userId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const put_ReservationExtension = (data: any, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}extension?userId=${userId}`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}


export const delete_ReservationExtension = (primaryKey: number, userId: number) => {
    return axios({
        url: `${baseURL}extension`,
        method: "DELETE",
        params: { id: primaryKey, userId: userId }
    }).then(response => response.data);
}

export const getReservationExtensionByReservationId = (primaryKey: number, tenantId: string) => {
    return getFetch(`extension/GetExtensionsByReservationId/${primaryKey}`, tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: params
    }).then(response => response.data);
}